// City guides. one page per DFW city we serve.
// SEO note: each gets its own URL + meta tags, ranks for "<city> homes for sale".

export const CITIES = [
  {
    slug: "fort-worth",
    name: "Fort Worth",
    headline: "Homes for Sale in Fort Worth, TX",
    blurb: "Fort Worth combines small-town friendliness with big-city amenities. From the Cultural District to TCU to the Stockyards, every neighborhood has its own personality and price point.",
    highlights: ["Strong school districts (FWISD, EMS-ISD)", "Median home price ~$340K", "Easy access to 35W and Chisholm Trail", "Growing tech + healthcare job market"],
    neighborhoods: ["Tanglewood", "Westover Hills", "Tavolo Park", "Park Glen", "Trinity Vista"],
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1600&q=80",
  },
  {
    slug: "arlington",
    name: "Arlington",
    headline: "Homes for Sale in Arlington, TX",
    blurb: "Arlington sits between Dallas and Fort Worth with strong school options, UT Arlington, and the entertainment district. Great value per square foot.",
    highlights: ["Mid-cities convenience", "Median home price ~$310K", "Strong rental demand near UTA", "Walking distance to Globe Life and AT&T Stadium in some neighborhoods"],
    neighborhoods: ["Cooper Creek", "Forest Hill", "Lakeridge", "Pantego", "Southlake border"],
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1600&q=80",
  },
  {
    slug: "dallas",
    name: "Dallas",
    headline: "Homes for Sale in Dallas, TX",
    blurb: "Dallas has it all. urban high-rises, historic districts, suburban neighborhoods. The biggest variety in DFW.",
    highlights: ["Best-in-class restaurant + arts scene", "Median home price ~$420K", "Easy DART transit access", "Top-tier private schools"],
    neighborhoods: ["Lakewood", "Lake Highlands", "Oak Cliff", "Bishop Arts", "Preston Hollow"],
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80",
  },
  {
    slug: "irving",
    name: "Irving",
    headline: "Homes for Sale in Irving, TX",
    blurb: "Irving. including Las Colinas. is one of DFW's most walkable, professional hubs. Strong corporate base, lakeside living, easy DFW Airport access.",
    highlights: ["DFW Airport on your doorstep", "Median home price ~$390K", "Strong corporate tenant base (Verizon, ExxonMobil, etc.)", "Las Colinas Mandalay Canal walkability"],
    neighborhoods: ["Valley Ranch", "Las Colinas", "MacArthur Park", "Songbird"],
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=80",
  },
  {
    slug: "frisco",
    name: "Frisco",
    headline: "Homes for Sale in Frisco, TX",
    blurb: "Frisco is one of the fastest-growing cities in America. New construction, top schools, and the headquarters of the Dallas Cowboys.",
    highlights: ["Frisco ISD. among Texas' best", "Median home price ~$600K", "Tons of new construction", "Sports + retail entertainment hub"],
    neighborhoods: ["Phillips Creek Ranch", "Newman Village", "Stonebriar", "Lone Star Ranch"],
    image: "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1600&q=80",
  },
  {
    slug: "plano",
    name: "Plano",
    headline: "Homes for Sale in Plano, TX",
    blurb: "Plano consistently ranks among the best places to live in America. Top schools (Plano ISD), corporate base, and family-friendly neighborhoods.",
    highlights: ["Plano ISD nationally ranked", "Median home price ~$560K", "Toyota, JPMorgan, Liberty Mutual HQs", "Legacy West shopping + dining"],
    neighborhoods: ["Willow Bend", "Legacy West", "Russell Creek", "Deerfield"],
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1600&q=80",
  },
  {
    slug: "southlake",
    name: "Southlake",
    headline: "Homes for Sale in Southlake, TX",
    blurb: "Southlake is DFW's premier luxury suburb. Carroll ISD, large lots, Town Square shopping, and tight-knit community.",
    highlights: ["Carroll ISD. perennial Texas powerhouse", "Median home price ~$1.1M", "Master-planned community feel", "Resort-style amenities"],
    neighborhoods: ["Carillon", "Timarron", "Estes Park", "Southlake Town Square area"],
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1600&q=80",
  },
  {
    slug: "mansfield",
    name: "Mansfield",
    headline: "Homes for Sale in Mansfield, TX",
    blurb: "Mansfield offers strong schools (Mansfield ISD), affordable inventory, and growing infrastructure. popular with first-time buyers and families.",
    highlights: ["Mansfield ISD. strong + growing", "Median home price ~$385K", "More house for the money", "Growing retail/dining scene"],
    neighborhoods: ["Walnut Creek Valley", "Magnolia Estates", "South Pointe", "Twin Creeks"],
    image: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=1600&q=80",
  },
  {
    slug: "grand-prairie",
    name: "Grand Prairie",
    headline: "Homes for Sale in Grand Prairie, TX",
    blurb: "Grand Prairie sits at the geographic heart of DFW. equal access to Dallas, Fort Worth, and Arlington. Strong value, family-friendly neighborhoods.",
    highlights: ["Central DFW location", "Median home price ~$345K", "Strong recreation (Lone Star Park, Joe Pool Lake)", "Good for commuters to either downtown"],
    neighborhoods: ["Lakeridge", "Westchester", "Camino Real", "Mira Lagos"],
    image: "https://images.unsplash.com/photo-1576941089067-2de3c901e126?w=1600&q=80",
  },
];

export function cityBySlug(slug) {
  return CITIES.find((c) => c.slug === slug) || null;
}
